import styled, { css } from 'styled-components';

type DayCardProps = {
  isUnabailable?: boolean;
  bgColor?: string;
  isToday?: boolean;
  isSelected?: boolean;
};

export const Container = styled.div<DayCardProps>`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 91px;
  height: 133px;
  cursor: pointer;

  ${({ isUnabailable }) =>
    isUnabailable &&
    css`
      background: #eff0f0;
    `}

  ${({ isToday }) =>
    isToday &&
    css`
      border-color: #3d3d3d;
    `}

  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: #0b29fb;
      background: #f0f2ff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    `}
`;

export const DayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 15px;
`;

export const WeekDay = styled.span<DayCardProps>`
  font-family: 'Mangueira';
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;

  ${({ isUnabailable }) =>
    isUnabailable &&
    css`
      color: #9f9f9f;
    `}
`;

export const Day = styled.span<DayCardProps>`
  font-family: 'Mangueira';
  font-weight: 600;
  font-size: 32px;
  line-height: 49px;
  color: #3d3d3d;

  ${({ isUnabailable }) =>
    isUnabailable &&
    css`
      color: #9f9f9f;
    `}
`;

export const StatusWrapper = styled.div<DayCardProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 89px;
  height: 37px;
  background: ${({ bgColor }) => bgColor};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;

  ${({ isUnabailable }) =>
    isUnabailable &&
    css`
      border-top: 1px solid #d9d9d9;
    `}
`;

export const Status = styled.span<DayCardProps>`
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #ffffff;

  ${({ isUnabailable }) =>
    isUnabailable &&
    css`
      color: #9f9f9f;
    `}
`;
